<template>
    <div>
        <div v-for="(accordion, index) in accordions" :key="index" class="tab w-full overflow-hidden pb-5">

            <h3 @click="accordion.opened = !accordion.opened"  class="flex justify-between items-center py-3 px-5 leading-normal cursor-pointer bg-primary text-white rounded-full">
                {{accordion.title}}
                <span v-if="accordion.opened" class="hover:bg-gray-500 rounded-full px-2 pb-1 text-xl font-bold text-white leading-none">–</span>
                <span v-else class="hover:bg-gray-500 rounded-full px-1.5 text-2xl font-bold text-white leading-none">+</span>
            </h3>

            <div :class="{'hidden':!accordion.opened, 'border':accordion.opened, }" class="tab-content overflow-hidden mt-1 rounded-2xl bg-white">
                <p class="p-5">{{accordion.description ? accordion.description : accordion.answer}}</p>
            </div>
        </div>
    </div>
</template>


<script>
import Fechar from "@/Components/UI/Icons/Fechar.vue"

export default{
  components:{ Fechar },
  props:{
      accordions:{
          type:Array,
          default: [],
      }
  }

};
</script>
